// import React, { useState } from 'react';
// import {
//     LineChart,
//     Line,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     Legend,
//     ResponsiveContainer
// } from 'recharts';
// import GraphModal from '../graphModal/GraphModal';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import FilterBadge from '../common/FilterBadge';
// import './monthlyLineChart.scss';
// import Skeleton from "@mui/material/Skeleton";

// const MonthlyLineChart = ({ title, data, loading, appliedFilters = [] }) => {
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [showFilters, setShowFilters] = useState(false);
//     const hasFilters = appliedFilters.length > 0 && !loading;

//     const handleOpenModal = () => setIsModalOpen(true);
//     const handleCloseModal = () => setIsModalOpen(false);

//     // Custom tooltip
//     const CustomTooltip = ({ active, payload, label }) => {
//         if (active && payload && payload.length) {
//             return (
//                 <div className="custom-tooltip">
//                     <p className="label">{`${label}`}</p>
//                     <p className="value">{`Average: ${payload[0].value}%`}</p>
//                 </div>
//             );
//         }
//         return null;
//     };

//     return (
//         <div
//             className="monthlyLineChartContainer"
//             onMouseEnter={() => setShowFilters(true)}
//             onMouseLeave={() => setShowFilters(false)}
//         >
//             <div className="chart-header">
//                 <h2 className="chartTitle">{title}</h2>
//                 {hasFilters && (
//                     <div className="filter-indicator">
//                         <FilterListIcon fontSize="small" />
//                     </div>
//                 )}
//             </div>

//             {hasFilters && showFilters && (
//                 <div className="filter-tooltip">
//                     <div className="filter-header">Applied Filters:</div>
//                     <div className="filter-badges">
//                         {appliedFilters.map((filter, index) => (
//                             <FilterBadge
//                                 key={index}
//                                 label={filter.label}
//                                 value={filter.value}
//                             />
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {loading ? (
//                 <Skeleton
//                     variant="rectangular"
//                     width="100%"
//                     height={400}
//                     animation="wave"
//                     className="chart-skeleton"
//                 />
//             ) : data.length > 0 ? (
//                 <>
//                     <div className="chart-wrapper" onClick={handleOpenModal}>
//                         <ResponsiveContainer width="100%" height={320}>
//                             <LineChart
//                                 data={data}
//                                 margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
//                             >
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} />
//                                 <YAxis domain={[0, 100]} />
//                                 <Tooltip content={<CustomTooltip />} />
//                                 <Legend />
//                                 <Line type="monotone" dataKey="Average" stroke="#8884d8" activeDot={{ r: 8 }} />
//                             </LineChart>
//                         </ResponsiveContainer>
//                     </div>

//                     <GraphModal isOpen={isModalOpen} onClose={handleCloseModal}>
//                         <ResponsiveContainer width="100%" height={500}>
//                             <LineChart
//                                 data={data}
//                                 margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
//                             >
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} />
//                                 <YAxis domain={[0, 100]} />
//                                 <Tooltip content={<CustomTooltip />} />
//                                 <Legend />
//                                 <Line type="monotone" dataKey="Average" stroke="#8884d8" activeDot={{ r: 8 }} />
//                             </LineChart>
//                         </ResponsiveContainer>
//                     </GraphModal>
//                 </>
//             ) : (
//                 <div className="no-data">No data available for selected filters</div>
//             )}
//         </div>
//     );
// };

// export default MonthlyLineChart;

import React, { useState } from "react";
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import GraphModal from "../graphModal/GraphModal";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterBadge from "../common/FilterBadge";
import Skeleton from "@mui/material/Skeleton";
import "./monthlyLineChart.scss";

const MonthlyLineChart = ({
  title,
  data = [],
  loading,
  appliedFilters = [],
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const hasFilters = appliedFilters.length > 0 && !loading;

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  // Format chart data (keeping structure consistent)
  const chartData = data.map((item) => ({
    name: item.name,
    value: item.Average || 0,
  }));

  const yDomain = [0, 100];

  return (
    <div
      className="monthlyLineChartContainer"
      onMouseEnter={() => setShowFilters(true)}
      onMouseLeave={() => setShowFilters(false)}
    >
      <div className="chart-header">
        <h2 className="chartTitle">{title}</h2>
        {hasFilters && (
          <div className="filter-indicator">
            <FilterListIcon fontSize="small" />
          </div>
        )}
      </div>

      {hasFilters && showFilters && (
        <div className="filter-tooltip top-left">
          <div className="filter-header">Applied Filters:</div>
          <div className="filter-badges">
            {appliedFilters.map((filter, index) => (
              <FilterBadge
                key={index}
                label={filter.label}
                value={filter.value}
              />
            ))}
          </div>
        </div>
      )}

      {loading ? (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={400}
          animation="wave"
          className="chart-skeleton"
        />
      ) : chartData.length > 0 ? (
        <>
          <div className="chart-wrapper" onClick={handleOpenModal}>
            <ResponsiveContainer width="100%" height={400}>
              <RechartsLineChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
                <YAxis domain={yDomain} />
                <Tooltip
                  formatter={(value) => [`${value.toFixed(2)}%`, "Average"]}
                  labelFormatter={(label) => `Month: ${label}`}
                />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#8884d8"
                  strokeWidth={2}
                  activeDot={{ r: 8 }}
                  name="Monthly Average"
                  label={({ x, y, value }) => (
                    <text
                      x={x}
                      y={y - 10}
                      fill="#8884d8"
                      fontSize={12}
                      fontWeight="bold"
                      textAnchor="middle"
                    >
                      {`${Math.round(value)}%`}
                    </text>
                  )}
                />
              </RechartsLineChart>
            </ResponsiveContainer>
          </div>

          <GraphModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            title={title}
          >
            <ResponsiveContainer width="100%" height={500}>
              <RechartsLineChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
                <YAxis domain={yDomain} />
                <Tooltip
                  formatter={(value) => [`${value.toFixed(2)}%`, "Average"]}
                  labelFormatter={(label) => `Month: ${label}`}
                />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#8884d8"
                  strokeWidth={2}
                  activeDot={{ r: 8 }}
                  name="Monthly Average"
                  label={({ x, y, value }) => (
                    <text
                      x={x}
                      y={y - 10}
                      fill="#8884d8"
                      fontSize={13}
                      fontWeight="bold"
                      textAnchor="middle"
                    >
                      {`${Math.round(value)}%`}
                    </text>
                  )}
                />
              </RechartsLineChart>
            </ResponsiveContainer>
          </GraphModal>
        </>
      ) : (
        <div className="no-data">No data available for selected filters</div>
      )}
    </div>
  );
};

export default MonthlyLineChart;
